export interface WorkflowStepConfig {
  /** Matches the `project.status` value persisted to the DB. */
  key: string;
  /** Display label shown in the stepper UI. */
  label: string;
  /** Page heading shown in the step view. Defaults to `label`. */
  pageTitle?: string;
  /** Label for the step's continue/complete action button. Defaults to 'Continue'. */
  continueLabel?: string;
}

// ─── Display labels ───────────────────────────────────────────────────────────

export const projectTypeLabel: Record<string, string> = {
  GVD: "Global Value Dossier",
  PICO: "PICO",
};

// ─── Badge variants ───────────────────────────────────────────────────────────

export const projectTypeVariant: Record<string, "default" | "brand2" | "secondary"> = {
  GVD: "default",
  PICO: "brand2",
};

// ─── Workflow steps ───────────────────────────────────────────────────────────

export const PICO_STEPS: WorkflowStepConfig[] = [
  { key: "Evidence Gathering", label: "Evidence Base", pageTitle: "Evidence Base", continueLabel: "Extract Data" },
  { key: "Extraction",         label: "PICO Extraction",    pageTitle: "PICO Extraction",    continueLabel: "Start Review" },
  { key: "Quality Assurance",  label: "Quality Assurance",  pageTitle: "Quality Assurance",  continueLabel: "Mark as Complete" },
  { key: "Complete",           label: "Complete" },
];

export const GVD_STEPS: WorkflowStepConfig[] = [
  { key: "Evidence Gathering", label: "Evidence Base", pageTitle: "Evidence Base", continueLabel: "Continue" },
  { key: "Outline Creation",   label: "Outline Creation",   pageTitle: "Outline Creation",   continueLabel: "Continue" },
  { key: "Extraction",         label: "Data Extraction",    pageTitle: "Data Extraction",    continueLabel: "Start Review" },
  { key: "Quality Assurance",  label: "Quality Assurance",  pageTitle: "Quality Assurance",  continueLabel: "Continue" },
  // Report Writing step removed from the UI — kept here commented out per [#7809].
  // { key: "Report Writing",     label: "Report Writing",     pageTitle: "Report Writing",     continueLabel: "Continue" },
  { key: "Complete",           label: "Complete" },
];

const WORKFLOW_MAP: Record<string, WorkflowStepConfig[]> = {
  PICO: PICO_STEPS,
  GVD: GVD_STEPS,
};

/**
 * Returns the step array for the given template type name (case-insensitive).
 * Falls back to PICO steps when the name is unrecognised or null.
 */
export function getWorkflowSteps(templateTypeName: string | null | undefined): WorkflowStepConfig[] {
  return WORKFLOW_MAP[templateTypeName?.toUpperCase() ?? ""] ?? PICO_STEPS;
}

/**
 * Returns only the steps shown in the stepper UI — excludes the "Complete" sentinel.
 */
export function getVisibleSteps(steps: WorkflowStepConfig[]): WorkflowStepConfig[] {
  return steps.filter((s) => s.key !== "Complete");
}
